import { LazyInViewport } from '@spa/components/Lazy'
import { useNavigatorType } from '@spa/core/browser'
import type { PropsWithChildren, FC, ReactElement, ReactNode } from 'react'
import React from 'react'

import EmptyRowPlaceholder from '../Placeholders/EmptyRowPlaceholder'

type Props = {
  fallback?: ReactNode
  className?: string
  children?: ReactElement
}

const LazyDisplay: FC<PropsWithChildren<Props>> = ({
  fallback = <EmptyRowPlaceholder />,
  className,
  children = null
}) => {
  const { isSafari } = useNavigatorType()

  if (isSafari) {
    return children as ReactElement
  }

  return (
    <LazyInViewport memoizeHeight fallback={fallback} className={className}>
      {children as ReactElement}
    </LazyInViewport>
  )
}

export default React.memo(LazyDisplay)
